const estadosList = [
    {id: 'inicioPartido', manual: 1, playing: false, label: 'Inicio Partido'},
    {id: 'sorteo', manual: 1, playing: false, label: 'Sorteo Inicial'},
    {id: 'calentamientox4', manual: 1, playing: false, label: 'Calentamiento<br>Ataque por 4'},
    {id: 'calentamientox2', manual: 1, playing: false, label: 'Calentamiento<br>Ataque por 2'},
    {id: 'calentamientoSaque', manual: 1, playing: false, label: 'Calentamiento<br>Saque'},
    {id: 'saludo', manual: 1, playing: false, label: 'Saludo Inicial'},
    {id: 'entregaFormaciones1', manual: 1, playing: false, label: 'Entrega Formaciones<br>1er Set'},
    {id: 'set1', manual: 0, playing: true, label: '1er Set'},
    {id: 'entregaFormaciones2', manual: 0, playing: false, label: 'Entrega Formaciones<br>2do Set'},
    {id: 'set2', manual: 0, playing: true, label: '2do Set'},
    {id: 'entregaFormaciones3', manual: 0, playing: false, label: 'Entrega Formaciones<br>3er Set'},
    {id: 'set3', manual: 0, playing: true, label: '3er Set'},
    {id: 'entregaFormaciones4', manual: 0, playing: false, label: 'Entrega Formaciones<br>4to Set'},
    {id: 'set4', manual: 0, playing: true, label: '4to Set'},
    {id: 'entregaFormaciones5', manual: 2, playing: false, label: 'Entrega Formaciones<br>5to Set'},
    {id: 'set5', manual: 0, playing: true, label: '5to Set'},
    {id: 'finPartido', manual: 0, playing: false, label: 'Fin del Partido'},
    {id: 'timeout', manual: 0, playing: false, label: 'Timeout'},
]  

const estados = {

    getDescripcion: function(curEstado) {
        let curEstadoObj = estadosList.find(estado => estado.id == curEstado);
        return (curEstadoObj || {}).label;
    },

    // return next status for app automatic trigger
    getNextAuto: function(curEstado) {
        let ret = null;
        if (curEstado == 'set1') ret = 'entregaFormaciones2';
        if (curEstado == 'set2') ret = 'entregaFormaciones3';
        if (curEstado == 'set3') ret = 'entregaFormaciones4';
        if (curEstado == 'set4') ret = 'entregaFormaciones5';
        if (curEstado == 'set5') ret = 'finPartido';
        return ret;
    },

    // return prev status for rollbacks
    getPrevAuto: function(curEstado, curSet = null) {

        let ret = null;
        if (curEstado == 'entregaFormaciones2') ret = 'set1';
        if (curEstado == 'entregaFormaciones3') ret = 'set2';
        if (curEstado == 'entregaFormaciones4') ret = 'set3';
        if (curEstado == 'entregaFormaciones5') ret = 'set4';
        if (curEstado == 'finPartido') {
            if (curSet == 3) ret = 'set3';
            if (curSet == 4) ret = 'set4';
            if (curSet == 5) ret = 'set5';
        }
        if (curEstado == 'set1') ret = 'inicioPartido';
        if (curEstado == 'set2') ret = 'entregaFormaciones2';
        if (curEstado == 'set3') ret = 'entregaFormaciones3';
        if (curEstado == 'set4') ret = 'entregaFormaciones4';
        if (curEstado == 'set5') ret = 'entregaFormaciones5';

        return ret;
    },
    
    // return next status for user manual trigger
    // if curEstado is a manual state return the next manual state of that group
    getNextManual: function(curEstado) {
        let ret = null;
        let curEstadoObj = estadosList.find(estado => estado.id == curEstado);
        
        // check that current estado is manual
        if (!curEstadoObj || !curEstadoObj.manual) return ret;

        let manualGroup = estadosList.filter(estado => estado.manual == curEstadoObj.manual);
        let manualGroupIndex = manualGroup.findIndex(estado => estado.id == curEstado);
        if (manualGroupIndex < manualGroup.length-1) ret = manualGroup[manualGroupIndex+1].id;
        return ret;
    },

    getPrevManual: function(curEstado) {
        let ret = null;
        let curEstadoObj = estadosList.find(estado => estado.id == curEstado);

        // check that current estado is manual
        if (!curEstadoObj || !curEstadoObj.manual) return ret;

        let manualGroup = estadosList.filter(estado => estado.manual == curEstadoObj.manual);
        let manualGroupIndex = manualGroup.findIndex(estado => estado.id == curEstado);
        if (manualGroupIndex > 0) ret = manualGroup[manualGroupIndex-1].id;
        return ret;
    },

    isPlaying: function(curEstado) {
        if (!curEstado) return false;
        let curEstadoObj = estadosList.find(estado => estado.id == curEstado);
        return curEstadoObj && curEstadoObj.playing;
    },

    // return if in curEstado its allowed to start a set
    canStartSet: function (curEstado) {
        if (!curEstado) return false;
        let curEstadoObj = estadosList.find(estado => estado.id == curEstado);
        
        return (curEstadoObj && curEstadoObj.manual == 1) ||    // manual group 1 is allowed
               (curEstadoObj && curEstadoObj.manual == 2) ||    // manual group 2 is allowed
               curEstado.indexOf('entregaFormaciones') == 0;    // any entregaFormaciones is allowed
    }
}

export default estados;